import Immutable from 'immutable';

export default Immutable.Record({
  src: undefined,
  title: undefined,
  artist: undefined,
  album: undefined,
  duration: undefined,
  isDrop: false,
  purchase: undefined
});


/** WEBPACK FOOTER **
 ** ./src/models/AudioFile.es6
 **/